import React, { useContext } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

//import context
import { GlobalProvider } from "context/GlobalContext";

const CustomNotification = () => {
  const {
    success,
    setSuccess,
    error,
    setError,
    notificationString,
    setNotificationString,
  } = useContext(GlobalProvider);

  const handleClose = () => {
    setSuccess(false);
    setError(false);
    setNotificationString("");
  };

  return (
    <Snackbar
      open={success || error || false}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={handleClose}
        severity={success ? "success" : "error"}
        sx={{ width: "100%" }}
      >
        {notificationString}
      </Alert>
    </Snackbar>
  );
};

export default CustomNotification;
